import React from 'react';
import { motion } from 'framer-motion';
import { getDayDiff } from '../utils/dateUtils';
import { useTheme } from '../context/ThemeContext';
import { useLocale } from '../context/LocaleContext';
import { getThemeStyle } from '../utils/themeUtils';
import SafeIcon from '../common/SafeIcon';

export default function CuteCountdownListRow({ item, onClick, onShare }) {
  const { isDark } = useTheme();
  const { t } = useLocale();
  const { diffDays, status, weekDayIndex } = getDayDiff(new Date(), item.targetDateISO);
  const currentStyle = getThemeStyle(item.theme, status, isDark);

  let label = t('common.remaining');
  if (status === 'today') label = t('common.today');
  if (status === 'elapsed') label = t('common.passed');

  const handleShare = (e) => {
    e.stopPropagation();
    onShare(item);
  };

  return (
    <motion.div
      whileHover={{ scale: 1.01, x: 5 }}
      whileTap={{ scale: 0.98 }}
      onClick={() => onClick(item)}
      className={`cursor-pointer rounded-2xl p-3 sm:p-4 shadow-sm border-2 ${isDark ? 'border-transparent hover:border-slate-600 bg-slate-800' : 'border-transparent hover:border-white bg-white'} transition-all duration-200 flex items-center gap-4 relative group`}
    >
      <div className={`w-12 h-12 shrink-0 rounded-xl flex items-center justify-center text-2xl shadow-inner bg-gradient-to-br ${currentStyle.bg}`}>
        {item.icon}
      </div>
      
      <div className="flex-1 min-w-0 pr-8">
        {/* 放寬到 line-clamp-2 確保在列表模式也能看見長標題 */}
        <h3 className={`font-bold text-base sm:text-lg line-clamp-2 break-words mb-0.5 ${isDark ? 'text-white' : 'text-gray-800'}`}>
          {item.isDemo && (
            <span className="inline-flex items-center px-1.5 py-0.5 rounded-md bg-gray-100 dark:bg-gray-700 text-pink-500 dark:text-pink-400 text-[10px] font-black mr-1.5 align-text-bottom">
              ✨ {t('common.demoBadge')}
            </span>
          )}
          {t(item.title)}
        </h3>
        <div className="flex items-center gap-2 text-xs sm:text-sm text-gray-500 dark:text-gray-400">
          <span>{item.targetDateISO}</span>
          <span className="hidden sm:inline">({t(`date.weekdays.${weekDayIndex}`)})</span>
          {item.note && <span className="truncate text-gray-400 dark:text-gray-500">- {t(item.note)}</span>}
        </div>
      </div>

      <div className="flex flex-col items-end shrink-0 relative z-10">
        <span className={`px-2 py-0.5 rounded-full text-[10px] sm:text-xs font-bold mb-1 ${currentStyle.badge}`}>
          {label}
        </span>
        {status !== 'today' && (
          <div className={`flex items-baseline gap-0.5 ${currentStyle.text}`}>
            <span className="text-xl sm:text-2xl font-black">{diffDays}</span>
            <span className="text-xs sm:text-sm font-bold">{t('common.days')}</span>
          </div>
        )}
      </div>

      <button 
        onClick={handleShare}
        className="absolute right-20 opacity-0 group-hover:opacity-100 p-2 rounded-full bg-gray-100 dark:bg-slate-700 text-gray-500 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-slate-600 transition-all"
      >
        <SafeIcon name="Share2" className="w-4 h-4" />
      </button>
    </motion.div>
  );
}